import { FileDropZone } from "../components/forms/dropzone/fileDropZone.type"

/**
 * Reporte/documento asociado a una autorizacion o condicionante.
 *
 * Extiende `FileDropZone` para reutilizar metadatos de carga (nombre, archivo, etc.).
 */
export interface Reporte extends FileDropZone{
  idRelacionado?: string
  idReporte?: string
  tipo?: 'AUTORIZACION' | 'CONDICIONANTE'
  nombre?: string
  ruta?: string
}

/** Estado de reportes en Redux. */
export interface ReporteState {
  reportes: Reporte[]
}

export const ReporteVacio: ReporteState = {
  reportes: [],
}
